var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useWatch } from 'react-hook-form';
import { WorkplaceServiceRequest } from '../../components/WorkplaceService/WorkplaceServiceRequest';
import { ComposerMode } from '../../types/index';
import { SpaceInfoWrapper } from '../SpaceDetails/EventSpaceWrapper';
import { useMemo } from 'react';
import { useSpaceDetailsContext } from '../SpaceDetails/SpaceDetailsContext';
import { useEventComposerGlobalContext } from '../../composers/EventComposerGlobalContext';
export var WorkplaceServiceRequestWrapper = function (_a) {
    var _b;
    var spaceId = _a.spaceId;
    var _c = useSpaceDetailsContext(), setWorkplaceServiceRequestFormStatus = _c.setWorkplaceServiceRequestFormStatus, handleWorkplaceServiceError = _c.handleWorkplaceServiceError, workplaceServiceRequestFormStatus = _c.workplaceServiceRequestFormStatus, onSuccessfulRequest = _c.onSuccessfulRequest, spaceForMeetingServiceData = _c.spaceForMeetingServiceData;
    var _d = useEventComposerGlobalContext(), composerMode = _d.composerMode, timezone = _d.timezone;
    var isEditMode = composerMode === ComposerMode.EDIT;
    var _e = __read(useWatch({
        name: [
            'startTime',
            'endTime',
            'spaces',
            'uid',
            'eventId',
            'recurrenceRule',
        ],
    }), 6), startTime = _e[0], endTime = _e[1], spaces = _e[2], uid = _e[3], eventId = _e[4], recurrenceRule = _e[5];
    var isRecurring = !!recurrenceRule;
    var space = useMemo(function () {
        return spaces === null || spaces === void 0 ? void 0 : spaces.find(function (space) { return space.id === spaceId; });
    }, [spaces, spaceId]);
    /* @TODO is it better to getValue here or watch? */
    var invitees = useWatch({
        name: 'invitees',
    });
    var showWorkplaceServiceRequest = (spaceForMeetingServiceData === null || spaceForMeetingServiceData === void 0 ? void 0 : spaceForMeetingServiceData.getSpacesByIds[0].hasAnyAvailableMeetingServices) &&
        (spaceForMeetingServiceData === null || spaceForMeetingServiceData === void 0 ? void 0 : spaceForMeetingServiceData.getSpacesByIds[0].currentUserCanRequestMeetingServicesForEvent);
    if (!showWorkplaceServiceRequest) {
        return null;
    }
    if (!space ||
        !space.id ||
        !space.levelId ||
        !space.locationId ||
        !timezone ||
        !startTime ||
        !endTime ||
        (!eventId && !uid)) {
        return null;
    }
    return (_jsx(SpaceInfoWrapper, { showBorder: false, style: {
            backgroundColor: 'white',
            borderRadius: '4px',
            paddingTop: '0px',
        }, children: _jsx(WorkplaceServiceRequest, { isRecurring: isRecurring, spaceId: space.id.toString(), levelId: space.levelId.toString(), locationId: space.locationId.toString(), onSubmitIframe: function () { return setWorkplaceServiceRequestFormStatus(undefined); }, onCloseIframe: function () { return setWorkplaceServiceRequestFormStatus(undefined); }, handleWorkplaceServiceError: handleWorkplaceServiceError, serviceRequestFormStatus: workplaceServiceRequestFormStatus, currentUserCanRequestServices: (_b = spaceForMeetingServiceData === null || spaceForMeetingServiceData === void 0 ? void 0 : spaceForMeetingServiceData.getSpacesByIds[0].currentUserCanRequestMeetingServicesForEvent) !== null && _b !== void 0 ? _b : false, onAddWorkplaceServiceRequest: function () {
                setWorkplaceServiceRequestFormStatus({
                    type: 'create',
                    serviceRequestId: null,
                });
            }, event: isEditMode
                ? {
                    type: 'existing',
                    id: eventId,
                }
                : {
                    type: 'draft',
                    uid: uid,
                    startTime: startTime.toISOString(),
                    endTime: endTime.toISOString(),
                    timezone: timezone,
                    numAttendees: invitees.length,
                }, onSuccessfulRequest: onSuccessfulRequest, editingEvent: isEditMode }) }));
};
